import { Experiences } from '@luxuryescapes/contract-svc-experience';

export const EXP_PROVIDER_REZDY: Experiences.Provider = 'Rezdy';
export const EXP_PROVIDER_LED: Experiences.Provider = 'LED';
export const EXP_PROVIDER_DERBYSOFT: Experiences.Provider = 'Derbysoft';
export const EXP_PROVIDER_KLOOK: Experiences.Provider = 'Klook';
export const EXP_PROVIDER_ASPIRE: Experiences.Provider = 'Aspire';
export const EXP_PROVIDER_COLLINSON: Experiences.Provider = 'Collinson';

export const EXP_PROVIDER_REZDY_PREFIX: Experiences.ProviderKey = 'rez';
export const EXP_PROVIDER_LED_PREFIX: Experiences.ProviderKey = 'led';
export const EXP_PROVIDER_DERBYSOFT_PREFIX: Experiences.ProviderKey = 'dby';
export const EXP_PROVIDER_KLOOK_PREFIX: Experiences.ProviderKey = 'klo';
export const EXP_PROVIDER_ASPIRE_PREFIX: Experiences.ProviderKey = 'asp';
export const EXP_PROVIDER_COLLINSON_PREFIX: Experiences.ProviderKey = 'cln';

export const PROVIDER_OPTIONS: Array<{ name: Experiences.Provider; value: Experiences.ProviderKey }> = [
  {
    name: EXP_PROVIDER_LED,
    value: EXP_PROVIDER_LED_PREFIX,
  },
  {
    name: EXP_PROVIDER_REZDY,
    value: EXP_PROVIDER_REZDY_PREFIX,
  },
  {
    name: EXP_PROVIDER_DERBYSOFT,
    value: EXP_PROVIDER_DERBYSOFT_PREFIX,
  },
  {
    name: EXP_PROVIDER_KLOOK,
    value: EXP_PROVIDER_KLOOK_PREFIX,
  },
  {
    name: EXP_PROVIDER_ASPIRE,
    value: EXP_PROVIDER_ASPIRE_PREFIX,
  },
  {
    name: EXP_PROVIDER_COLLINSON,
    value: EXP_PROVIDER_COLLINSON_PREFIX,
  },
];
